<template>
  <div>
    <button :tabindex="tabindex" class="k-button k-primary" href="#" @click="addClick">
      <span class="icon icon-add"></span>
    </button>
    <button :tabindex="tabindex" :title="fluidComments" :class="fluidButtonClass" href="#" @click="editClick">
      <span class="icon icon-comments"></span>
    </button>
    <FluidAddEditForm
      ref="addEditRef"
      @submit-add-edit-form="onFormSubmit"
      :isEditMode="isEditMode"
      :startingFluidTypeID="startingFluidTypeID"
    />
  </div>
</template>

<script>
import AjaxDataService from 'services/ajax.service';
import FormMixin from '../shared/FormMixin';
import FluidAddEditForm from './FluidAddEditForm';
import FluidTypeConstants from '../../constants/fluid-types.constants';
import FluidClassConstants from '../../constants/fluid-class.constants';
import Endpoint from '../../constants/api/endpoint/fluid.endpoint.constants';
import Constants from '../../constants/constants';

export default {
  name: 'FluidAutoCompleteAddEdit',
  data() {
    return {
      columnConstants: Constants.ColumnName.Fluid,
      idField: Constants.ColumnName.Fluid.fluidId.field,
      apiRoute: Endpoint.data,
      deletePrecheck: Endpoint.deletePrecheck,
      buttonClass: 'k-button k-primary',
      isEditMode: false
    };
  },
  props: {
    fluidData: {
      type: Object,
      default: () => ({})
    },
    tabindex: {
      type: Number,
      default: -1
    },
    startingFluidTypeID: {
      type: Number,
      default: 1
    }
  },
  computed: {
    fluidComments: function() {
      return this.fluidData?.fluidComments ? this.fluidData.fluidComments : '';
    },
    fluidButtonClass: function() {
      return this.fluidData?.fluidComments ? this.buttonClass + ' has-comments' : this.buttonClass;
    }
  },
  methods: {
    addClick() {
      this.isEditMode = false;
      this.$refs.addEditRef.openDialog({
        fluidTypeID: FluidTypeConstants.OilId,
        fluidTypeName: FluidTypeConstants.Oil,
        fluidClass: FluidClassConstants.NA,
        fluidClassID: FluidClassConstants.NAId
      });
    },
    editClick() {
      this.isEditMode = true;
      this.$refs.addEditRef.openDialog({
        ...this.fluidData,
        fluidClass: this.fluidData.fluidClass ? this.fluidData.fluidClass : FluidClassConstants.NA,
        fluidClassID: this.fluidData.fluidClassID ? this.fluidData.fluidClassID : FluidClassConstants.NAId
      });
    },
    onFormSubmit(formData, _, isDelete, resolve) {
      if (isDelete) {
        const params = { id: formData.fluidID };
        AjaxDataService.getData(this.deletePrecheck, params)
          .then(response => response.data)
          .then(relatedItems => {
            if (relatedItems.count > 0) {
              resolve([`This item cannot be deleted. There are ${JSON.stringify(relatedItems.description)} related items.`]);
            } else {
              resolve(['This item cannot be deleted. There are related items.']);
            }
          });
      } else {
        delete formData.modifiedOn;
        this.clearBlankLookupIDs(formData);
        AjaxDataService.postData(this.apiRoute, formData).then(fluid => {
          if (fluid.data) {
            this.$emit('added-fluid', fluid.data);
          }
          resolve([]);
        });
      }
    }
  },
  components: { FluidAddEditForm },
  mixins: [FormMixin]
};
</script>

<style scoped>
button:focus {
  outline: -webkit-focus-ring-color auto 3px;
}

.has-comments {
  background-color: #FFDE66 !important;
  background-image: none !important;
  border-color: #FFDE66 !important;
  color: #000 !important;
}
</style>
